var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseWhite9X9 = function SvgCloseWhite9X9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.557 4.499 3.222-3.215A.752.752 0 1 0 7.715.22L4.5 3.442 1.286.22A.752.752 0 1 0 .222 1.284l3.222 3.214L.222 7.713a.752.752 0 1 0 1.064 1.064L4.5 5.555l3.214 3.222a.752.752 0 1 0 1.064-1.064Z"
  })));
};
export default SvgCloseWhite9X9;